import { Box, Link, Text } from '@nimbus-ds/components';
import { Link as LinkRoute } from 'react-router-dom';
import { ExternalLink, useResponsive } from 'commons/components';
import { Leading } from './Leading';
import { ActionType, ContentType, TaskActionData, TaskData } from '../types';

interface TaskContentProps {
  data: TaskData & TaskActionData;
  contentType: ContentType;
  actionType: ActionType;
  onAction: (data: TaskData & TaskActionData) => void;
}

const GAP_MAP = {
  promoteGrouped: 'none',
  promote: '3',
  recommendation: '2',
} as const;

function TaskContent({
  data,
  contentType,
  actionType,
  onAction,
}: TaskContentProps) {
  const { isMobile: isMobileResponsive } = useResponsive();
  const isVideo = Boolean(data.videoId);

  return (
    <Box
      display="flex"
      gap={GAP_MAP[contentType]}
      alignItems={isVideo ? 'center' : undefined}
    >
      <Leading
        isVideo={isVideo}
        data={data}
        contentType={contentType}
        onAction={onAction}
      />
      <Box display="flex" flexDirection="column" gap="none" alignSelf="center">
        <Box maxWidth="380px">
          <Text
            fontSize="caption"
            color="neutral-textHigh"
            lineHeight="caption"
          >
            {data.title}
          </Text>
        </Box>

        <Text fontSize="caption" color="neutral-textLow" lineHeight="caption">
          {data.description}
        </Text>
        {isMobileResponsive && ['alert', 'promote'].includes(actionType) && (
          <Box>
            {data.ctaExternal ? (
              <ExternalLink
                href={data.ctaLink}
                textDecoration="none"
                appearance="primary"
                fontSize="caption"
                onClick={() => onAction(data)}
              >
                {data.ctaText}
              </ExternalLink>
            ) : (
              <Link
                data-style="task-action-link"
                textDecoration="none"
                appearance="primary"
                fontSize="caption"
                lineHeight="caption"
                as={LinkRoute}
                onClick={() => onAction(data)}
                to={data.ctaLink || '#'}
              >
                {data.ctaText || 'Acción'}
              </Link>
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default TaskContent;
